module.exports = __webpack_public_path__ + "static/DSC_9362-7ad2e5f859046e4971f56fbd0023daac.jpg";